const getParams = window.location.search
  .substr(1)
  .split('&')
  .reduce((acc, keyValue) => {
    const match = keyValue.match(/^(.+?)=(.+?)$/);
    if (!match) return acc;
    return {
      ...acc,
      [match[1]]: match[2],
    };
  }, {});

// eslint-disable-next-line import/prefer-default-export
export function debugValue(defaultValue, overrideName) {
  if (
    process.env.NODE_ENV === 'development' &&
    typeof getParams[overrideName] !== 'undefined'
  ) {
    const val = getParams[overrideName];
    if (val.match(/^\d+$/)) return Number(val);
    return val;
  }

  return defaultValue;
}
